module.exports = __webpack_public_path__ + "img/defaultProductIco.5726b966.png";